import { HERO_IMAGE } from "@/mocks/comics";

export default function Hero() {
  return (
    <section id="home" className="relative flex min-h-[560px] w-full items-center justify-center overflow-hidden md:min-h-[640px]">
      <div
        className="absolute inset-0 bg-cover bg-center object-cover"
        style={{ backgroundImage: `url(${HERO_IMAGE})` }}
        aria-hidden="true"
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-background-50"></div>

      <div className="relative z-10 mx-auto flex w-full max-w-4xl flex-col items-center px-4 py-24 text-center md:py-32">
        <span className="mb-5 inline-flex items-center gap-2 rounded-full bg-secondary-400/90 px-4 py-1.5 text-xs font-medium text-foreground-900 md:text-sm">
          <i className="ri-fire-fill text-accent-500"></i>
          全网最会整活的搞笑漫画站 · 每日更新
        </span>
        <h1 className="font-heading text-4xl leading-tight text-background-50 md:text-6xl">
          韩国歪歪漫画
        </h1>
        <p className="mt-4 max-w-2xl text-base text-background-100 md:text-lg">
          专供搞笑与无厘头内容，收录沙雕日常、神吐槽、梗图段子。打开即看搞笑合集，
          无厘头剧情持续更新，找乐子就上韩国歪歪漫画。
        </p>

        <div className="mt-7 flex flex-wrap items-center justify-center gap-2">
          {["沙雕日常", "神吐槽", "梗图段子", "无厘头剧场"].map((c) => (
            <span
              key={c}
              className="rounded-full bg-background-50/15 px-3.5 py-1.5 text-xs text-background-50 backdrop-blur-sm md:text-sm"
            >
              #{c}
            </span>
          ))}
        </div>

        <div className="mt-9 flex w-full flex-col items-center gap-3 sm:flex-row sm:justify-center">
          <a
            href="#collections"
            className="w-full whitespace-nowrap rounded-full bg-primary-500 px-8 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            去刷沙雕合集
          </a>
          <a
            href="#rants"
            className="w-full whitespace-nowrap rounded-full border border-background-50/70 px-8 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/15 sm:w-auto"
          >
            看神吐槽段子
          </a>
        </div>
      </div>
    </section>
  );
}